import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  title: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
  },
  paper: {
    paddingBottom: theme.spacing(3),
    minHeight: '500px',
    maxHeight: '500px',
  },
  chart: {
    maxHeight: '450px',
  },
}))

export default useStyles
